import { useMemo } from "react"

import { Typography } from "@mui/material"
import { useDropzone } from "react-dropzone"

import { Trans, useTranslation } from "@l2r-front/l2r-i18n"
import { UploadFileRoundedIcon } from "@l2r-front/l2r-icons"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import { FileViewer } from "../FileViewer"

import * as Styled from "./DropZone.styled"

export function DropZone(props) {
    const {
        acceptedFileText,
        className,
        file,
        ...dropZoneProps
    } = props

    const isMobile = useIsMobileDevice()
    const { t } = useTranslation(I18N_NAMESPACE)
    const {
        isFocused,
        isDragAccept,
        isDragReject,
        fileRejections,
        getRootProps,
        getInputProps,
        open,
    } = useDropzone(dropZoneProps)

    const errorText = useMemo(() => {
        if (fileRejections.length > 0) {
            return fileRejections[0].errors[0].message
        } else if (isDragReject) {
            return t(I18N_NAMESPACE, "components.dropzone.rejectedFilesText")
        }
        return null
    }, [fileRejections, isDragReject, t])

    return (
        <>
            <Styled.Container className={className} hidden={!!file} {...getRootProps({ isFocused, isDragAccept, isDragReject })}>
                <input {...getInputProps()} />
                <UploadFileRoundedIcon color={errorText ? "inherit" : "primary"} />
                <Typography variant="Desktop & Mobile/Body/Regular">
                    <Trans
                        namespace={I18N_NAMESPACE}
                        i18nKey={isMobile ? "components.dropzone.clickTextMobile" : "components.dropzone.clickText"}
                        components={{
                            FakeLink: <Styled.FakeLink disabled={!!errorText} />,
                        }}
                    />
                </Typography>
                {errorText ?
                    <Styled.RejectedFilesText variant="Desktop & Mobile/Body/Small">{errorText}</Styled.RejectedFilesText>
                    : <Styled.AcceptedFilesText variant="Desktop & Mobile/Body/Small">{acceptedFileText ?? t(I18N_NAMESPACE, "components.dropzone.acceptedFilesText")}</Styled.AcceptedFilesText>}
            </Styled.Container>
            {file && <FileViewer className={className} file={file} onFileChange={open} />}
        </>
    )
}